export default function RouteLoading() {
   return (
      <div className="d-flex justify-content-center p-4" role="status" aria-live="polite">
         <span className="spinner-border text-primary" aria-hidden="true" />
         <span className="sr-only">Loading page…</span>
      </div>
   );
}
